import { ExchangePrice } from './exchange-price';
import { Currency } from './currency';
import { TickerInfo } from './ticker';

export interface PriceAlert {
    id: string;
    active: boolean;
    pair: string;
    minPrice: ExchangePrice;
    maxPrice: ExchangePrice;
    types: PriceAlertType[];
}

export interface PriceAlertFullInfo {
    currency: Currency;
    ticker: TickerInfo;
    priceAlert: PriceAlert;
}

export enum PriceAlertType {
    SMS = 'SMS',
    EMAIL = 'EMAIL'
}
